/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type LastPromptUpdateInput = {
    lastPromptTime: string;
    clientMutationId?: string | null;
};
export type LastPromptUpdateMutationVariables = {
    input: LastPromptUpdateInput;
};
export type LastPromptUpdateMutationResponse = {
    readonly lastPromptUpdate: {
        readonly clientMutationId: string | null;
    } | null;
};
export type LastPromptUpdateMutation = {
    readonly response: LastPromptUpdateMutationResponse;
    readonly variables: LastPromptUpdateMutationVariables;
};



/*
mutation LastPromptUpdateMutation(
  $input: LastPromptUpdateInput!
) {
  lastPromptUpdate(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LastPromptUpdatePayload",
    "kind": "LinkedField",
    "name": "lastPromptUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LastPromptUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LastPromptUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3d5bf18b6a396843d7205844275e61b6",
    "id": null,
    "metadata": {},
    "name": "LastPromptUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation LastPromptUpdateMutation(\n  $input: LastPromptUpdateInput!\n) {\n  lastPromptUpdate(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '24a7a471863695d9dd33b10fdcd96b8f';
export default node;
